













import Vue, { PropType } from 'vue';
import { ContractRenewalStateEnum, IContract } from '@/models';

export default Vue.extend({
  name: 'ContractRenewalStatusBanner',

  props: {
    contract: { type: Object as PropType<IContract>, required: true }
  },

  computed: {
    getBannerColor(): string {
      if (this.contract.isContractRenewed()) return 'green';
      return this.contract.getRenewalStateColor();
    },

    contractRenewalStatusIcon(): string {
      let icon = '';
      switch (this.contract.renewal_state) {
        case ContractRenewalStateEnum.AwaitingConfirmation: {
          icon = 'mdi-alert';
          break;
        }

        case ContractRenewalStateEnum.ConfirmedWithChanges: {
          icon = 'mdi-file-check-outline';
          break;
        }

        case ContractRenewalStateEnum.ConfirmedWithoutChanges: {
          icon = 'mdi-check';
          break;
        }

        case ContractRenewalStateEnum.Declined: {
          icon = 'mdi-close';
          break;
        }
      }

      return icon;
    },

    contractRenewalStatusMessage(): string {
      let message = 'Contract ';

      switch (this.contract.renewal_state) {
        case ContractRenewalStateEnum.AwaitingConfirmation: {
          message += 'is awaiting customer confirmation';
          break;
        }
        case ContractRenewalStateEnum.ConfirmedWithChanges: {
          message += 'renewal is confirmed with changes';
          break;
        }
        case ContractRenewalStateEnum.ConfirmedWithoutChanges: {
          message += 'renewal is confirmed';
          break;
        }
        case ContractRenewalStateEnum.Declined: {
          message += 'is not to be renewed';
          break;
        }
      }

      return message;
    }
  }
});
